import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { SurveyDefinitionDto } from "@api";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { first } from "rxjs/operators";
import { AppRoutes } from "src/app/constants";
import { NavigationService } from "src/app/services/navigation/navigation.service";
import { RootState } from "src/app/store";
import * as SurveyActions from "src/app/store/survey/actions";
import * as FromSurvey from "src/app/store/survey/selectors";
import * as FromRouter from "src/app/store/router/selectors";

@Component({
  selector: "app-success",
  templateUrl: "./success.page.html",
  styleUrls: ["./success.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccessPage implements OnInit {
  public loading$: Observable<boolean> = this.store.select(FromSurvey.selectLoading);
  public definition$: Observable<SurveyDefinitionDto>;

  constructor(private store: Store<RootState>, private navigationService: NavigationService) {}

  public ngOnInit(): void {
    this.store
      .select(FromRouter.selectSlugFromQueryParams)
      .pipe(first())
      .subscribe(slug => {
        this.definition$ = this.store.select(FromSurvey.selectDefinitionBySlug(slug));
        this.store.dispatch(SurveyActions.getDefinitionBySlug({ slug }));
      });
  }

  public done(): void {
    this.definition$.pipe(first()).subscribe(definition => {
      this.navigationService.handleNavigationTo(definition?.successButtonLink || AppRoutes.home);
    });
  }
}
